// contains configuration options used to render the Chart.js charts for the national view before a city or park are selected.

import { nationalStats } from "../../constants";
export const nationalChartOptions = (data: any, labels: any) => {
  const compareLabelsPopulationWithin: any = {
    "White*": "white",
    "Black*": "black",
    "Native American*": "nativeAmerican",
    "Asian*": "asian",
    "Pacific Islander*": "pacificIslander",
    "Other Race*": "other",
    "Two or More Races*": "twoOrMore",
    Hispanic: "hispanic",
    "Low Income (<75% MAI)": "lowIncomeHouse",
    "Medium Income (75%-125% MAI)": "medIncomeHouse",
    "High income (>125% MAI)": "highIncomeHouse",
    "Youth (<20)": "kids",
    "Adults (20-64)": "adults",
    "Seniors (>64)": "seniors",
  };

  return {
    maintainAspectRatio: false,
    indexAxis: "y" as const,
    scales: {
      y: {
        ticks: {
          font: {
            size: 11,
          },
          callback: (e: any) => {
            // Custom callback function to wrap labels to a maximum line length of 15 characters
            // Access the label at the correct index
            const label = labels[e]
            // If the label is less than or equal to 15 characters in length, return that label
            if (label.length <= 15) {
              return label
            } else {
              let startIndex = 0
              const labelArray = []
              // Iterate over the label string and add substrings of 15 characters or less, separated by space characters
              while (startIndex < label.length) {
                let endIndex = startIndex + 15;
                if (endIndex + 1 >= label.length) {
                  labelArray.push(label.substring(startIndex).trim())
                } else {
                  while (endIndex > startIndex && label[endIndex] !== ' ') {
                    endIndex--;
                  }
                  if (endIndex === startIndex) {
                    endIndex = startIndex + 15
                  }
                  labelArray.push(label.substring(startIndex, endIndex).trim());
                }
                startIndex = endIndex + 1;
              }
              return labelArray
            }
          }
        },
      },

      x: {
        ticks: {
          font: {
            size: 11,
          },
        },
        min: 0,
        max: 100,
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    redraw: true,
    plugins: {
      title: {
        display: false,
        text: "Chart.js Horizontal Bar Chart",
      },
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context: any) {
            return (
              " " +
              nationalStats.TotalPopWithin[
                compareLabelsPopulationWithin[context.label]
              ].toLocaleString()
            );
          },
        },
      },
      datalabels: {
        display: true,
        color: "black",
        formatter: function (val: any) {
          return "   " + val.toLocaleString("en-US") + "%";
        },
      },
    },
  };
};
